// Pure helpers behind the Configuration tab (components/device/DeviceConfigPanel.jsx): the wake-interval presets
// and wording, local date-time <-> Unix seconds for the wake schedule, and the General fields' checks.

export const WAKE_PRESETS = [
  { seconds: 900, label: "15 min" },
  { seconds: 1800, label: "30 min" },
  { seconds: 3600, label: "1 hour" },
  { seconds: 3 * 3600, label: "3 hours" },
  { seconds: 6 * 3600, label: "6 hours" },
];

/** 3600 -> "1 hour", 5400 -> "1 h 30 min", 900 -> "15 min". */
export function describeInterval(seconds) {
  const total = Math.round(Number(seconds) / 60);
  if (!Number.isFinite(total) || total <= 0) return "—";
  const hours = Math.floor(total / 60);
  const minutes = total % 60;
  if (hours === 0) return `${minutes} min`;
  if (minutes === 0) return hours === 1 ? "1 hour" : `${hours} hours`;
  return `${hours} h ${minutes} min`;
}

const pad = (n) => String(n).padStart(2, "0");

/** Unix seconds -> "YYYY-MM-DDTHH:mm" in the browser's local time, for <input type="datetime-local">. */
export function epochToLocalInput(epochSeconds) {
  const d = new Date(epochSeconds * 1000);
  return `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())}T${pad(d.getHours())}:${pad(d.getMinutes())}`;
}

/** The input's local date-time -> Unix seconds, or null when it is empty or not a date. */
export function localInputToEpoch(value) {
  if (!value) return null;
  const ms = new Date(value).getTime();
  return Number.isFinite(ms) ? Math.floor(ms / 1000) : null;
}

/**
 * Checks for the General card. `name` blocks saving (a device needs a name); `eid` and `iccid` only warn, since a
 * value the backend already holds may not follow today's format and should not stop other changes being saved.
 */
export function validateIdentity({ name = "", eid = "", iccid = "" }) {
  const errors = {};
  if (!name.trim()) errors.name = "Give the device a name.";
  const eidValue = eid.trim();
  if (eidValue && !/^\d{32}$/.test(eidValue)) errors.eid = `An EID is 32 digits; this has ${eidValue.replace(/\D/g, "").length}.`;
  const iccidValue = iccid.trim();
  if (iccidValue && !/^\d{19,20}$/.test(iccidValue)) errors.iccid = "An ICCID is 19 or 20 digits.";
  return errors;
}
